import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import style from "../../styles/gestionEncuesta.module.css";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import i18n from "../../features/i18n";
import ReactivarEncuestaPopup from "./ReactivarEncuestaPopup";

const GestionEncuesta = ({ onClose, onDelete, onFinalizar, onAplicar, surveyGroups, sendNow, onAmpliar, idEmpresa }) => {
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState(Object.keys(surveyGroups)[0]);
    const [openTabs, setOpenTabs] = useState(Object.keys(surveyGroups));
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    const [selectedStartDate, setSelectedStartDate] = useState(yesterday);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [selectedPredefined, setSelectedPredefined] = useState(null);
    const [reminderDate, setReminderDate] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [contenidoCorreo, setContenidoCorreo] = useState('');
    const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false); // Estado para el popup de confirmación
    const [isConfirmDeletePopupOpen, setIsConfirmDeletePopupOpen] = useState(false);
    const [isConfirmFinalizePopupOpen, setIsConfirmFinalizePopupOpen] = useState(false);
    const [isAmpliarPopupOpen, setIsAmpliarPopupOpen] = useState(false);
    const [encuestaParaAmpliar, setEncuestaParaAmpliar] = useState(null);
    const [selectedLanguage, setSelectedLanguage] = useState('en'); // Idioma por defecto: inglés



    // Confirmación del popup
    const handleConfirmSend = () => {
        setIsConfirmPopupOpen(false); // Cerrar popup de confirmación
        sendNow(selectedTab); // Ejecutar la función del padre
        setOpenTabs(prevOpenTabs => {
            const updatedTabs = prevOpenTabs.filter(tab => tab !== selectedTab);
            if (updatedTabs.length > 0) {
                setSelectedTab(updatedTabs[0]);
            } else {
                onClose();
            }
            return updatedTabs;
        });
    };

    // Cancelar la acción del popup
    const handleCancelSend = () => {
        setIsConfirmPopupOpen(false); // Cerrar popup sin hacer nada
    };

    // Función para manejar el clic en el botón de envío
    const handleSendNowClick = () => {
        setIsConfirmPopupOpen(true); // Mostrar el popup de confirmación
    };
    
    useEffect(() => {
        const selectedSurvey = surveyGroups[selectedTab];
        if (selectedSurvey && selectedSurvey.encuesta.fechas) {
            const [start, end] = selectedSurvey.encuesta.fechas.split(' - ');
            setSelectedStartDate(new Date(start + "T00:00:00")); // Ajuste para garantizar la hora local
            setSelectedEndDate(new Date(end + "T00:00:00")); // Ajuste para garantizar la hora local
        }
        if (selectedSurvey && selectedSurvey.encuesta.recordatorio) {
            setReminderDate(new Date(selectedSurvey.encuesta.recordatorio));
        } else {
            setReminderDate(null);
        }
    
        if (selectedSurvey && selectedSurvey.encuesta.idioma) {
            // Asegurarse de que el idioma esté en minúsculas para el selector
            const idioma = selectedSurvey.encuesta.idioma.toString().toLowerCase();
            setSelectedLanguage(idioma === 'es' ? 'es' : 'en');
            
            // Si hay contenido personalizado, usarlo; si no, usar el predeterminado según el idioma de la encuesta
            if (selectedSurvey && selectedSurvey.encuesta.contenidoCorreo) {
                setContenidoCorreo(selectedSurvey.encuesta.contenidoCorreo);
            } else {
                // Obtener el texto predeterminado en el idioma de la encuesta sin cambiar el idioma global
                const langCode = idioma === 'es' ? 'es' : 'en';
                setContenidoCorreo(i18n.t("defaultEmailContent", { lng: langCode }));
            }
        } else {
            setSelectedLanguage('en'); // Por defecto inglés
            // Si no hay encuesta o no tiene idioma, usar inglés por defecto
            if (selectedSurvey && selectedSurvey.encuesta.contenidoCorreo) {
                setContenidoCorreo(selectedSurvey.encuesta.contenidoCorreo);
            } else {
                // Por defecto inglés
                setContenidoCorreo(i18n.t("defaultEmailContent", { lng: 'en' }));
            }
        }
    }, [selectedTab, surveyGroups]);
    
    
    
    function handleReminderDateChange(event) {
        setReminderDate(event.target.value ? new Date(event.target.value) : null);
    }
    

    const opcionesIdioma = [
        {
            value: "es",
            label: (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <img
                        src="/img/banderas/es.png"
                        alt="ES"
                        style={{ width: "20px", height: "15px" }}
                    />
                    <span>{t("spanish")}</span>
                </div>
            ),
        },
        {
            value: "en",
            label: (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <img
                        src="/img/banderas/en.png"
                        alt="EN"
                        style={{ width: "20px", height: "15px" }}
                    />
                    <span>{t("english")}</span>
                </div>
            ),
        },
    ];

    // Función para actualizar el contenido del correo cuando cambia el idioma
    const handleLanguageChange = (opcion) => {
        const nuevoIdioma = opcion.value;
        setSelectedLanguage(nuevoIdioma);
        
        // Si no hay contenido personalizado o es el texto predeterminado, actualizar según el nuevo idioma
        const selectedSurvey = surveyGroups[selectedTab];
        const defaultTextES = i18n.t("defaultEmailContent", { lng: 'es' });
        const defaultTextEN = i18n.t("defaultEmailContent", { lng: 'en' });
        
        if (!selectedSurvey || !selectedSurvey.encuesta.contenidoCorreo || 
            contenidoCorreo === defaultTextES || contenidoCorreo === defaultTextEN) {
            // Actualizar el texto predeterminado según el nuevo idioma
            setContenidoCorreo(i18n.t("defaultEmailContent", { lng: nuevoIdioma }));
        }
    };

    const handleApply = (surveyId) => {
        const selectedSurvey = surveyGroups[surveyId];

        // Asegurarse de que onAplicar devuelva una promesa y manejar los errores
        onAplicar(selectedStartDate, selectedEndDate, reminderDate, surveyId, selectedSurvey.equipos, contenidoCorreo, selectedLanguage)
            .then(() => {
                setOpenTabs(prevOpenTabs => {
                    const updatedTabs = prevOpenTabs.filter(tab => tab !== surveyId);
                    if (updatedTabs.length > 0) {
                        setSelectedTab(updatedTabs[0]);
                    } else {
                        onClose();
                    }
                    return updatedTabs;
                });
            })
            .catch(error => {
                // Manejar el error si es necesario
                console.error("Error al aplicar la encuesta:", error?.message || error);
            });
    };
    
    function getFirstDayOfMonth(year, month) {
        return new Date(year, month, 1).getDay();
    }

    function getMonthName(monthNumber) {
        const monthNames = [
            t("january"),
            t("february"),
            t("march"),
            t("april"),
            t("may"),
            t("june"),
            t("july"),
            t("august"),
            t("september"),
            t("october"),
            t("november"),
            t("december"),
        ];
        return monthNames[monthNumber];
    }

    function handleDayClick(day) {
        const date = new Date(currentYear, currentMonth, day);
        date.setHours(0, 0, 0, 0); // Aseguramos que esté en la hora local

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        // No permitir fecha de inicio anterior al día actual
        if (date < today) return;
    
        if (
            (!selectedStartDate && !selectedEndDate) ||
            (selectedStartDate && selectedEndDate)
        ) {
            setSelectedStartDate(date);
            setSelectedEndDate(null);
            setSelectedPredefined(null);
        } else if (selectedStartDate && !selectedEndDate) {
            if (date < selectedStartDate) {
                setSelectedEndDate(selectedStartDate);
                setSelectedStartDate(date);
            } else {
                setSelectedEndDate(date);
            }
            setSelectedPredefined(null);
        }
    }
    

    function handleNextMonth() {
        const newDate = new Date(currentYear, currentMonth + 1);
        setCurrentMonth(newDate.getMonth());
        setCurrentYear(newDate.getFullYear());
    }

    function handlePreviousMonth() {
        const newDate = new Date(currentYear, currentMonth - 1);
        setCurrentMonth(newDate.getMonth());
        setCurrentYear(newDate.getFullYear());
    }

    const handleClickOutside = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };



    function renderCalendar(disabled = false) {
        const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
        const firstDayOfMonth = getFirstDayOfMonth(currentYear, currentMonth);
        const paddingDays = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;
        const days = [];
        
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Establecer la hora en 0 para comparaciones
    
        for (let i = 1; i <= paddingDays + daysInMonth; i++) {
            const day = i - paddingDays;
            const date = new Date(currentYear, currentMonth, day);
            date.setHours(0, 0, 0, 0);

            const isPastDay = day > 0 && date < today;
            const isToday = date.getTime() === today.getTime(); // Comparar con hoy
            const isSelectedDay =
                (selectedStartDate && date.getTime() === selectedStartDate.getTime()) ||
                (selectedEndDate && date.getTime() === selectedEndDate.getTime());
            const isInRange =
                selectedStartDate && selectedEndDate
                    ? date > selectedStartDate && date < selectedEndDate
                    : false;
            const isStartRange =
                selectedStartDate && date.getTime() === selectedStartDate.getTime();
            const isEndRange =
                selectedEndDate && date.getTime() === selectedEndDate.getTime();
            const isClickable = day > 0 && !disabled && !isPastDay;

            days.push(
                <div
                    key={i}
                    className={` ${style.calendarDay} ${isToday ? style.today : ""} ${isSelectedDay ? style.selectedDay : ""} ${isInRange ? style.inRangeDay : ""} ${isStartRange ? style.startRangeDay : ""} ${isEndRange ? style.endRangeDay : ""} ${day <= 0 ? style.paddingDay : ""} ${isPastDay ? style.pastDay : ""}`}
                    onClick={isClickable ? () => handleDayClick(day) : undefined}
                >
                    {day > 0 ? day : ""}
                </div>,
            );
        }
    
        return <div className={style.days}>{days}</div>;
    }
    

    const handlePredefinedClick = (weeks) => {
        const startDate = new Date();
        startDate.setHours(0, 0, 0, 0); // Reset time to midnight
        const endDate = new Date(startDate); // Clone startDate to endDate
        endDate.setDate(startDate.getDate() + weeks * 7); // Add weeks
        setSelectedStartDate(startDate);
        setSelectedEndDate(endDate);
        setSelectedPredefined(weeks);
    };
    

    const handleDeleteEncuesta = () => {
        onDelete(selectedTab);
        setOpenTabs(prevOpenTabs => {
            const updatedTabs = prevOpenTabs.filter(tab => tab !== selectedTab);
            if (updatedTabs.length > 0) {
                setSelectedTab(updatedTabs[0]);
            } else {
                onClose();
            }
            return updatedTabs;
        });
    };

    const handleFinalizarEncuesta = () => {
        onFinalizar(selectedTab);
        setOpenTabs(prevOpenTabs => {
            const updatedTabs = prevOpenTabs.filter(tab => tab !== selectedTab);
            if (updatedTabs.length > 0) {
                setSelectedTab(updatedTabs[0]);
            } else {
                onClose();
            }
            return updatedTabs;
        });
    };

    return ReactDOM.createPortal(
        <div className={style.popupOverlay} onClick={handleClickOutside}>
            <div className={style.popupContent}>
                <div className={style.tabs}>
                    {openTabs.map((surveyId) => (
                        <div 
                            key={surveyId}
                            className={`${style.tab} ${selectedTab === surveyId ? style.activeTab : ""}`}
                            onClick={() => setSelectedTab(surveyId)}
                        >
                            {surveyId === 'no-encuesta' ? t("newSurvey") : `${t("survey")} ${new Date(surveyGroups[surveyId].encuesta.fechas.split(' - ')[0]).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' })} - ${new Date(surveyGroups[surveyId].encuesta.fechas.split(' - ')[1]).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' })}`}
                        </div>
                    ))}
                </div>
                {openTabs.map((surveyId) => {
                    const isSurveyActive = surveyGroups[surveyId].encuesta.estado === 'activa';
                    return selectedTab === surveyId && (
                        <div key={surveyId} className={style.tabContent}>
                            <div className={style.popupGrid}>
                                <div className={style.calendarContainer}>
                                    <div className={`${style.calendario} ${isSurveyActive ? style.disabled : ''}`}>
                                        <p className={style.fechaño}>{getMonthName(currentMonth)}<br></br>{currentYear}</p>
                                        <div className={style.datepicker}>
                                            <button onClick={isSurveyActive ? undefined : handlePreviousMonth} disabled={isSurveyActive}>
                                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 600 960" width="24" > <path d="M400-93.847 13.847-480 400-866.153l56.768 56.768L127.384-480l329.384 329.385L400-93.847Z" /> </svg>
                                            </button>
                                            <button onClick={isSurveyActive ? undefined : handleNextMonth} disabled={isSurveyActive}>
                                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 800 960" width="24"><path d="m320.615-93.847-56.768-56.768L593.232-480 263.847-809.385l56.768-56.768L706.768-480 320.615-93.847Z" /> </svg>
                                            </button>
                                        </div>
                                        <div className={style.dayLabels}>
                                            <div>{t("monday")}</div>
                                            <div>{t("tuesday")}</div>
                                            <div>{t("wednesday")}</div>
                                            <div>{t("thursday")}</div>
                                            <div>{t("friday")}</div>
                                            <div>{t("saturday")}</div>
                                            <div>{t("sunday")}</div>
                                        </div>
                                        {renderCalendar(isSurveyActive)}
                                    </div>
                                </div>
                                <div className={style.gestionFechasEquipos}>
                                    {surveyGroups[surveyId].equipos?.length > 0 && (
                                        <div className={style.equiposEncuestaLinea}>
                                            <span className={style.equiposEncuestaLabel}>{t("surveyForTeams")}</span>
                                            <span className={style.equipoChip}>{surveyGroups[surveyId].equipos[0].nombre}</span>
                                        </div>
                                    )}
                                    <div className={style.fechasiniciofin}>
                                        <div className={style.fechainicio}>
                                            <p>{t("startDate")}</p>
                                            <p>{selectedStartDate.toLocaleDateString()}</p>
                                        </div>
                                        <div className={style.fechafin}>
                                            <p>{t("endDate")}</p>
                                            <p>{selectedEndDate ? selectedEndDate.toLocaleDateString() : selectedStartDate.toLocaleDateString()}</p>
                                        </div>

                                        <div className={style.fechafin}>
                                            <p>{t("reminderDate")}</p>
                                            <div className={style.dateInputWrapper}>
                                                <input 
                                                    type="date" 
                                                    className={style.dateInput}
                                                    value={reminderDate ? reminderDate.toISOString().split('T')[0] : ""} 
                                                    onChange={handleReminderDateChange}
                                                />
                                            </div>
                                        </div>

                                        <div className={style.fechafin}>
                                            <p>{t("surveyLanguage")}</p>
                                            <div style={{ minWidth: '200px' }}>
                                                <Select
                                                    options={opcionesIdioma}
                                                    value={opcionesIdioma.find(opcion => opcion.value === selectedLanguage)}
                                                    onChange={handleLanguageChange}
                                                    isDisabled={isSurveyActive}
                                                    menuPlacement="top"
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '40px',
                                                            borderRadius: '8px',
                                                        }),
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        
                                        

                                    </div>
                                    <div className={`${style.fechasPredefinidas} ${isSurveyActive ? style.disabled : ''}`}>
                                        <div className={`${style.predefinida} ${selectedPredefined === 1 ? style.active : ""}`} onClick={!isSurveyActive ? () => handlePredefinedClick(1) : undefined}> <p>{t("1week")}</p>
                                        </div>
                                        <div className={`${style.predefinida} ${selectedPredefined === 2 ? style.active : ""}`} onClick={!isSurveyActive ? () => handlePredefinedClick(2) : undefined}><p>{t("2week")}</p></div>
                                        <div className={`${style.predefinida} ${selectedPredefined === 3 ? style.active : ""}`} onClick={!isSurveyActive ? () => handlePredefinedClick(3) : undefined}> <p>{t("3week")}</p></div>
                                    </div>
                                    {/* Texto informativo de que 24 se enviará un recordatorio */}
                                    <div className={style.recordatorio}>
                                        <p>{isSurveyActive ? t("activeSurveyOnlyReminder") : t("reminderText")}</p>
                                    </div>
                                    {/* Botón para modificar correo: no mostrar cuando la encuesta está activa */}
                                    {!isSurveyActive && (
                                        <div className={style.divModificarCorreo}>
                                            <button 
                                                className={style.modifyMailwithIcon} 
                                                onClick={() => setIsSidebarOpen(true)}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1.2000000000000002 -2.4000000000000004 26.4 32.4"><path d="M22,8v4c0,.55-.45,1-1,1s-1-.45-1-1v-4c0-.55-.45-1-1-1H5c-.55,0-1,.45-1,1v8c0,.55,.45,1,1,1h6c.55,0,1,.45,1,1s-.45,1-1,1H5c-1.65,0-3-1.35-3-3V8c0-1.65,1.35-3,3-3h14c1.65,0,3,1.35,3,3Zm-4.07,1.61c-.21-.51-.79-.76-1.3-.56l-4.64,1.86-4.63-1.85c-.51-.21-1.1,.04-1.3,.56-.21,.51,.04,1.09,.56,1.3l5,2c.12,.05,.25,.07,.37,.07s.25-.02,.37-.07l5.01-2.01c.51-.21,.76-.79,.56-1.3Zm1.55,5c-.39-.39-1.02-.39-1.41,0l-3.54,3.54c-.11,.11-.19,.24-.24,.39l-.71,2.12c-.12,.36-.03,.76,.24,1.02,.19,.19,.45,.29,.71,.29,.11,0,.21-.02,.32-.05l2.12-.71c.15-.05,.28-.13,.39-.24l3.54-3.54c.39-.39,.39-1.02,0-1.41l-1.41-1.41Z"/></svg>
                                                {t('modifyEmail')}
                                            </button>
                                        </div>
                                    )}
                                    {/* <div className={style.equiposSeleccionados}>
                                        <ul>
                                            {surveyGroups[surveyId].equipos.map((team) => (
                                                <li key={team.id_equipo}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m424-312 282-282-56-56-226 226-114-114-56 56 170 170ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"/></svg>
                                                    {team.nombre}
                                                </li>
                                            ))}
                                        </ul>
                                    </div> */}
                                    <div className={style.divButtonsPopup}>
                                    {/* Mostrar el botón solo si la encuesta estado es programada */}
                                    {surveyGroups[surveyId].encuesta.estado === 'programada' && (
                                        <button
                                            className={style.buttonSendNow}
                                            onClick={handleSendNowClick}
                                        >
                                            <span className={style.buttonText}>{t("sendNow")}</span>
                                        </button>
                                    )}
                                    {/* Mostrar el botón Ampliar solo si la encuesta está activa (no cuando está programada) */}
                                    {surveyGroups[surveyId].encuesta.estado === 'activa' && (
                                        <button 
                                            className={style.buttonAmpliar}
                                            onClick={() => {
                                                const equipos = surveyGroups[surveyId].equipos;
                                                const idEquipo = equipos?.[0]?.id_equipo;
                                                setEncuestaParaAmpliar({
                                                    ...surveyGroups[surveyId].encuesta,
                                                    id_encuesta: surveyGroups[surveyId].encuesta.id,
                                                    fechas: surveyGroups[surveyId].encuesta.fechas,
                                                    _idEquipo: idEquipo
                                                });
                                                setIsAmpliarPopupOpen(true);
                                            }}
                                        >
                                            {t("ampliar")}
                                        </button>
                                    )}
                                    {/* Mostrar el botón Finalizar solo si la encuesta está activa */}
                                    {surveyGroups[surveyId].encuesta.estado === 'activa' && (
                                        <button 
                                            className={style.buttonFinalize} 
                                            onClick={() => setIsConfirmFinalizePopupOpen(true)}
                                        >
                                            {t("finalize")}
                                        </button>
                                    )}
                                    {/* No mostrar Eliminar cuando es una nueva encuesta (no-encuesta) */}
                                    {surveyId !== 'no-encuesta' && (
                                        <button className={style.buttonDelete} onClick={() => setIsConfirmDeletePopupOpen(true)}>{t("delete")}</button>
                                    )}
                                        <button className={style.buttonCancel} onClick={() => onClose()}>{t("cancel")}</button>
                                        <button className={style.buttonApply} onClick={() => handleApply(surveyId)}>{t("apply")}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {isSidebarOpen && (() => {
                const lng = selectedLanguage;
                const monthKeys = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
                const deadlineDate = (selectedEndDate || selectedStartDate)
                    ? `📅 ${(selectedEndDate || selectedStartDate).getDate()} ${t(monthKeys[(selectedEndDate || selectedStartDate).getMonth()], { lng })} ${(selectedEndDate || selectedStartDate).getFullYear()}`
                    : '';
                return (
                <div className={style.popupOverlay}>
                    <div className={style.sidebarMail}>
                        <div className={style.sidebarHeader}>
                            <h2>{t('modifyEmail')}</h2>
                            <button className={style.closeButtonMail} onClick={() => setIsSidebarOpen(false)}>{t('close')}</button>
                        </div>
                        <div className={style.sidebarContent}>
                            <div className={style.sidebarPreviewScroll}>
                                <div style={{ fontFamily: 'Arial, sans-serif', color: '#333', backgroundColor: '#f4f4f4', padding: '1rem 2rem', fontSize: '14px', lineHeight: 1.6 }}>
                                    <table width="100%" style={{ backgroundColor: '#f4f4f4' }}>
                                        <tr>
                                            <td>
                                                <table align="center" width="100%" style={{ backgroundColor: '#ffffff', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                                                    <tr>
                                                        <td style={{ textAlign: 'center', padding: '20px 20px 10px 20px' }}>
                                                            <img src="/img/systemic horizontal.svg" alt="Logo Systemic" width="150" style={{ maxWidth: '150px', margin: '0 auto' }} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ color: '#333', padding: '0 20px 20px 20px' }}>
                                                            <p style={{ margin: '0 0 20px 0' }}>{t("emailInvitationHello", { lng })}</p>
                                                            <p style={{ margin: '0 0 20px 0' }} dangerouslySetInnerHTML={{ __html: t("emailInvitationWelcome", { lng }) }} />
                                                            {deadlineDate && (
                                                                <>
                                                                    <p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>{t("emailInvitationDeadlineLabel", { lng })}</p>
                                                                    <p style={{ margin: '0 0 20px 0' }}>{deadlineDate}</p>
                                                                </>
                                                            )}
                                                            <p style={{ margin: '0 0 20px 0' }} dangerouslySetInnerHTML={{ __html: t("emailInvitationAnonymous", { lng }) }} />
                                                            <p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: t("emailInvitationWhatTitle", { lng }) }} />
                                                            <p style={{ margin: '0 0 8px 0' }}>{t("emailInvitationWhatIntro", { lng })}</p>
                                                            <ul style={{ margin: '0 0 20px 0', paddingLeft: 20, lineHeight: 1.6 }}>
                                                                <li style={{ margin: '0 0 4px 0' }} dangerouslySetInnerHTML={{ __html: t("emailInvitationDim1", { lng }) }} />
                                                                <li style={{ margin: '0 0 4px 0' }} dangerouslySetInnerHTML={{ __html: t("emailInvitationDim2", { lng }) }} />
                                                            </ul>
                                                            <p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: t("emailInvitationStructTitle", { lng }) }} />
                                                            <p style={{ margin: '0 0 8px 0' }}>{t("emailInvitationStructIntro", { lng })}</p>
                                                            <ul style={{ margin: '0 0 8px 0', paddingLeft: 20, lineHeight: 1.6 }}>
                                                                <li style={{ margin: '0 0 4px 0' }} dangerouslySetInnerHTML={{ __html: t("emailInvitationStruct1", { lng }) }} />
                                                                <li style={{ margin: '0 0 4px 0' }} dangerouslySetInnerHTML={{ __html: t("emailInvitationStruct2", { lng }) }} />
                                                                <li style={{ margin: '0 0 4px 0' }} dangerouslySetInnerHTML={{ __html: t("emailInvitationStruct3", { lng }) }} />
                                                                <li style={{ margin: '0 0 4px 0' }} dangerouslySetInnerHTML={{ __html: t("emailInvitationStruct4", { lng }) }} />
                                                            </ul>
                                                            <p style={{ margin: '0 0 20px 0' }}>{t("emailInvitationStructLeader", { lng })}</p>
                                                            <p style={{ textAlign: 'center', margin: '20px 0' }}>
                                                                <span style={{ backgroundColor: '#e3147f', color: '#FFFFFF', textDecoration: 'none', fontWeight: 'bold', padding: '12px 24px', borderRadius: '5px', display: 'inline-block', opacity: 0.7 }}>
                                                                    {t("completeSurvey", { lng })}
                                                                </span>
                                                            </p>
                                                            <p style={{ margin: '0 0 20px 0' }} dangerouslySetInnerHTML={{ __html: t("emailInvitationContact", { lng }) }} />
                                                            <p style={{ margin: '0 0 20px 0' }}>{t("emailInvitationThanks", { lng })}</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'center', padding: '20px 20px 10px 20px', fontSize: '12px', color: '#aaa' }}>
                                                            <p style={{ margin: '0 0 5px 0' }}>8incompany</p>
                                                            <p style={{ margin: 0 }}>clientsupport@systemicsurvey.com</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className={style.contenidoModificable3} style={{ textAlign: 'center', padding: '10px 20px 30px 20px', fontSize: '0.8em', color: '#aaa' }}>
                                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                                                                <img className={style.logoInstitutoImg} src="/img/logoInstituto8color.png" alt="Logo Instituto 8" />
                                                                <p>Powered by</p>
                                                                <img className={style.logoFeelinback} src="/img/logo_largo.png" alt="" />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <button className={style.saveButton} onClick={() => setIsSidebarOpen(false)}>{t("save")}</button>
                        </div>
                    </div>
                </div>
                );
            })()}
            {isConfirmPopupOpen && (
                <div className={style.confirmOverlay}>
                    <div className={style.confirmPopup}>
                        <h2>{t("sendNow?")}</h2>
                        <p>{t("confirmSendNowEmail")}</p>
                        <div className={style.confirmButtons}>
                            <button onClick={handleConfirmSend} className={style.confirmButton}>{t("confirm")}</button>
                            <button onClick={handleCancelSend} className={style.cancelButton}>{t("cancel")}</button>
                        </div>
                    </div>
                </div>
            )}

                {isConfirmDeletePopupOpen && (
                    <div className={style.confirmOverlay}>
                        <div className={style.confirmPopup}>
                            <h2>{t("deleteSurvey?")}</h2>
                            <p>{t("confirmDeleteSurvey")}</p>
                            <div className={style.confirmButtons}>
                                <button 
                                    onClick={() => {
                                        handleDeleteEncuesta(); // Ejecutar la eliminación
                                        setIsConfirmDeletePopupOpen(false); // Cerrar el popup
                                    }} 
                                    className={style.confirmButton}
                                >
                                    {t("confirm")}
                                </button>
                                <button 
                                    onClick={() => setIsConfirmDeletePopupOpen(false)} 
                                    className={style.cancelButton}
                                >
                                    {t("cancel")}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {isConfirmFinalizePopupOpen && (
                    <div className={style.confirmOverlay}>
                        <div className={style.confirmPopup}>
                            <h2>{t("finalizeSurvey?")}</h2>
                            <p>
                                {t("confirmFinalizeSurvey").split('?')[0]}?<br />
                                {t("confirmFinalizeSurvey").split('?').slice(1).join('?').trim()}
                            </p>
                            <div className={style.confirmButtons}>
                                <button 
                                    onClick={() => {
                                        handleFinalizarEncuesta(); // Ejecutar la finalización
                                        setIsConfirmFinalizePopupOpen(false); // Cerrar el popup
                                    }} 
                                    className={style.confirmButton}
                                >
                                    {t("confirm")}
                                </button>
                                <button 
                                    onClick={() => setIsConfirmFinalizePopupOpen(false)} 
                                    className={style.cancelButton}
                                >
                                    {t("cancel")}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {isAmpliarPopupOpen && encuestaParaAmpliar && idEmpresa && encuestaParaAmpliar._idEquipo && onAmpliar && (
                    <ReactivarEncuestaPopup
                        modo="ampliar"
                        encuesta={encuestaParaAmpliar}
                        idEquipo={encuestaParaAmpliar._idEquipo}
                        idEmpresa={idEmpresa}
                        onClose={() => {
                            setIsAmpliarPopupOpen(false);
                            setEncuestaParaAmpliar(null);
                        }}
                        onConfirm={async (datos) => {
                            try {
                                await onAmpliar(datos);
                                setIsAmpliarPopupOpen(false);
                                setEncuestaParaAmpliar(null);
                            } catch {
                                setIsAmpliarPopupOpen(false);
                                setEncuestaParaAmpliar(null);
                            }
                        }}
                    />
                )}

        </div>,
        document.body
    );
};

export default GestionEncuesta;